import type {RouteRecordRaw} from "vue-router";

const routes: RouteRecordRaw[] = [
    {
        path: 'messaging',
        children: [
            {
                path: 'email-templates',
                children: [
                    {
                        path: '',
                        name: 'administration.messaging.mailTemplates',
                        component: () => import("@/modules/messaging/views/MailTemplatesIndex.vue"),
                    },
                    {
                        path: ':mailTemplateId',
                        name: 'administration.messaging.mailTemplate',
                        props: true,
                        component: () => import("@/modules/messaging/views/MailTemplateShow.vue"),
                    }
                ]
            },
        ]
    },
];


export default routes;
